var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"page-image",attrs:{"src":require("@/assets/images/404/404-01.png")}})])
}]

export { render, staticRenderFns }